import { useReducer } from 'react';
import { Address, AddressRequestStatus } from '../@types/address';

export enum AddressListActions {
  Reset = 'Reset',
  Fetch = 'Fetch',
  SetData = 'SetData',
  SetError = 'SetError',
}

export type AddressListState =
  | {
      addressList: null;
      addressListStatus: Exclude<AddressRequestStatus, AddressRequestStatus.Success>;
    }
  | {
      addressList: Address[];
      addressListStatus: AddressRequestStatus.Success;
    };

const initialAddressListState = {
  addressList: null,
  addressListStatus: AddressRequestStatus.Initial,
} as const;

export type AddressListDispatchAction =
  | {
      type: Exclude<AddressListActions, AddressListActions.SetData>;
    }
  | {
      type: AddressListActions.SetData;
      value: Address[];
    };

function addressListReducer(state: AddressListState, action: AddressListDispatchAction) {
  switch (action.type) {
    case AddressListActions.Fetch:
      return { addressList: null, addressListStatus: AddressRequestStatus.Fetching } as const;

    case AddressListActions.SetData:
      return {
        addressList: action.value,
        addressListStatus: AddressRequestStatus.Success,
      } as const;

    case AddressListActions.SetError:
      return { addressList: null, addressListStatus: AddressRequestStatus.Error } as const;

    case AddressListActions.Reset:
      return initialAddressListState;

    default:
      return state;
  }
}

export function useAddressListReducer() {
  return useReducer(addressListReducer, initialAddressListState);
}
